 $(document).ready(function() {
  $('#search').keyup(function() {
    var searchValue = ($(this).val()).trim();
    var searchlen = searchValue.length;
    var term = searchValue+"*";
    var term1 = term.trim();
    var searchURL = '/search?type=product&q=' +term;
    var resultsList = $('#results');
    if (term1.length < 2){
      resultsList.html('');
      $('#resultsnumber').empty();
    }
    if (term1.length >= 2) {
      $.ajax({
        type : 'GET',
        url : searchURL+ '&view=json',
        dataType : 'json',
        success : function(result){ 
          resultsList.html('');
          $('#resultsnumber').empty();
          var p = 0;
//           console.log(result);
          if(result.results_count > 0){
            $.each(result.results, function(index, item) {
                var tags = item.tags;
              var handle = item.url;
             // if(item.id != window.theme.gwp_product)
             // {
                    if(p <= 3 ){
                      $('#results').append(`
							<div class="card ajax_search serc cstm_card" product-qty="${item.quantity}" product-id="${item.id}" product-title="${item.title}" product-price="${parseInt(item.pricewithoutmoney)}" variant-id="${item.variantid}" variant-title="${item.variant_title}" product-type="${item.product_type}">
                             <a href="${item.url}">
                                 <img class="card-img-top" src="${item.thumbnail}" alt="Card image cap">
                                 <div class="card-body">
                                     <h5 class="card-title product__grid__title">${item.title}</h5>
                                     <p class="card-text"> ${item.price}</p>
                                 </div>
                             </a>
                         </div> `)
                      p++;
                  }
             // }
            });
            if(result.results_count > 3) {
              $('#resultsnumber').append('<div id="allProducts" class="see_all_product"><span class="title"><a href="' + searchURL + '">See all Products (' + result.results_count + ')</a></span></div>');
            }
          }else{
            var q = 0;
            $.ajax({
              type : "GET",
              url : "https://ponds.in/collections/all/products.json",
              dataType : "json",
              async : false,
              success : function(data){
                $.each(data.products, function(index, item) {
                  var tags = item.tags;
                  var price = parseInt(item.variants[0].price);
                   // if(item.variants[0].id != window.theme.gwp_product){
                    if(q <= 3 ){
                      $('#results').append(`
							<div class="card ajax_search rec cstm_card" product-qty="${item.quantity}" product-id="${item.id}" product-title="${item.title}" product-price="${parseInt(item.pricewithoutmoney)}" variant-id="${item.variantid}" variant-title="${item.variant_title}" product-type="${item.product_type}">
                             <a href="/products/${item.handle}">
                                 <img class="card-img-top" src="${item.images[0].src}" alt="Card image cap">
                                 <div class="card-body">
                                     <h5 class="card-title product__grid__title ">${item.title}</h5>
                                     <p class="card-text"> ₹${price}</p>
                                 </div>
                             </a>
                         </div>
                        
                     `)
                      q++;
                    }
                   // }
                });
                if(data.products.length > 3) {
                  $('#resultsnumber').append('<div id="allProducts" class="see_all_product"><span class="title"><a href="' + searchURL + '">See all Products (' + data.products.length + ')</a></span></div>');
                }
              },
              error : function(){
                console.log("error best seller");
              }
            });
          }
        },
        error : function(){
          console.log('search error');
        }
      });
    }
    
    if (event.keyCode === 13) {
       location.href = searchURL;
    }
    
  });
  $('.search__popdown__close__inner').on('click', function(){
    var resultsList = $('#results');
    resultsList.html('');
    $('#resultsnumber').empty();
    $('#search').val('');
  });
});